import type {CustomerAnalysisOptions} from "./CustomerAnalysisOptions.ts";
import type {Setter} from "../../util/setter/Setter.ts";
import {useFieldSetter} from "../../util/setter/FieldSetter.ts";
import {SuspenseLayer} from "../../util/suspense/SuspenseLayer.tsx";
import {ProjectSelector} from "../../analysis-process/2-option-selection/project-selection/ProjectSelector.tsx";
import {CheckboxField} from "../../components/checkbox-field/CheckboxField.tsx";

interface Props {
    options: CustomerAnalysisOptions
    setOptions: Setter<CustomerAnalysisOptions>
}
export function CustomerProjectOptionsBlock({options, setOptions}: Props) {
    const [project, setProject] = useFieldSetter(options, setOptions, "selectedProjects")
    return <div>
        <CheckboxField value={project.analyzeAll}
                       setValue={(newValue)=>setProject(old =>({...old, analyzeAll: newValue}))}
                       title={"Analyze all projects"}
                       description={project.analyzeAll ? "The default version in every project will be analyzed" : "Please select which project versions to analyze"}
                       small
                   />
        {!project.analyzeAll && <SuspenseLayer><ProjectSelector project={project} setProject={setProject} /></SuspenseLayer> }
    </div>
}
